module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/12Ix4Eh/tc-custom/9780738721446.jpg?1741985248648",
      "alt": "This image is the cover for the book Cunningham's Book of Shadows"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Cunningham's Book of Shadows\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("A long-lost Book of Shadows from an icon in the magical community, featuring original spells, rituals, invocations, and an herbal grimoire.")])]), _c('p', [_c('b', [_vm._v("“Wiccan readers will treasure this blast from the past as one final word from the revered teacher.” ―")]), _c('i', [_c('b', [_vm._v("Library Journal")])])]), _c('p', [_vm._v("Llewellyn is pleased to present a new Scott Cunningham book―a long-lost Book of Shadows. Discovered in a battered manila envelope, this previously unpublished manuscript was penned by Scott in the early 1980s. This rare book includes original spells, rituals, invocations, and an herbal grimoire. Featured in the design are Scott's actual hand-drawn signs, symbols, and runes.")]), _c('p', [_vm._v("More than twenty years after his passing, Scott Cunningham is still an iconic and highly regarded figure in the magical community. His books on Wicca are considered classics, and his writings continue to inspire and inform those new to the Craft. ")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Scott Cunningham\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Scott Cunningham practiced magic actively for over twenty years. He was the author of more than fifty books covering both fiction and non-fiction subject matter; sixteen of his titles are published by Llewellyn Publications. Scott's books reflect a broad range of interests within the New Age sphere, where he was very highly regarded. He passed from this life on March 28, 1993, after a long illness. "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Llewellyn Publications is an imprint of Llewellyn Worldwide Ltd.\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0